import { createContext } from 'react';
import type { PlatformBrandingPublicDto } from '@/core/platform-branding/platform-branding';

export type PlatformBrandingContextValue = {
  branding: PlatformBrandingPublicDto;
  refresh: () => Promise<void>;
};

export const BrandingUiContext = createContext<PlatformBrandingContextValue | null>(null);
